import { UI_ModuleInfo } from "../../../../UI_ITO/indexUI";
import { PurchaseInfoListWithComponentRow } from "../../../../interfaces/PurchaseInfoListWithComponentRow";
import { Form } from "antd";
import { IPurchaseInfoItem } from "../../../../interfaces/IPurchaseInfoItem";
import { PurchaseInfoProps } from "../../../../interfaces/props/PurchaseInfoProps";

import classes from "../PurchaseInfo.module.css";

/**
 * Компонент отображает информацию о закупке.
 *
 * @param {PurchaseInfoProps} props - Свойства компонента
 * @param {PurchaseInfoListWithComponentRow<IPurchaseInfoItem>} props.info - Информация о закупке
 * @param {FormInstance<IPurchaseInfoFormValues>} props.formChange - Экземпляр формы для редактирования
 */
export function PurchaseInfo(props: PurchaseInfoProps) {
  const { info, formChange } = props;

  return (
    <Form className={classes.form} form={formChange}>
      {Object.keys(info)?.map((item) => {
        const itemKey =
          item as keyof PurchaseInfoListWithComponentRow<IPurchaseInfoItem>;
        const title = itemKey;
        const renderText = {
          author: "Автор заявки",
          purchase: "Закупка",
          client: "Клиент",
          customer: "Заказчик",
          auction: "Аукцион",
          price_contact: "Цена контракта",
          start_end_bg: "Начало и окончание БГ",
        };

        return (
          <UI_ModuleInfo
            className={classes.sectionInfo}
            key={renderText[title]}
            data={info[itemKey]}
            title={renderText[title as keyof typeof renderText]}
          />
        );
      })}
    </Form>
  );
}
